
import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'


export default {
props: {
xmIconList: {
type: Array,
default: null
},
highLightId: {
type: String,
default: ""
}
},

components: {
Swiper,
SwiperItem
},

methods: {
clickTag(iconItem) {
this.$emit("click-tag", iconItem);
}
}
};



// WEBPACK FOOTER //
// ./src/components/xc_time/album-tags/album-tags-phone.vue